import { render, staticRenderFns } from "./AdminDonationsDetails.vue?vue&type=template&id=795d3d5c&scoped=true"
import script from "./AdminDonationsDetails.vue?vue&type=script&lang=js"
export * from "./AdminDonationsDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminDonationsDetails.vue?vue&type=style&index=0&id=795d3d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d3d5c",
  null
  
)

export default component.exports